import { render, staticRenderFns } from "./component.vue?vue&type=template&id=2c3c9c8b&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3c9c8b')) {
      api.createRecord('2c3c9c8b', component.options)
    } else {
      api.reload('2c3c9c8b', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=2c3c9c8b&", function () {
      api.rerender('2c3c9c8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-time-relative/component.vue"
export default component.exports